import { ProductPosition } from "shared/types/ProductPosition"

import { useClarificationRequestModel } from "entities/clarification-requests/model/useClarificationRequestModel"
import { clarificationRequestResourceTypeMap } from "entities/clarification-requests/types/ClarificationRequest"
import { useProjectPermissions } from "entities/projects/model/useProjectPermissions"
import { readonlyProjectPermissions } from "entities/projects/types/ProjectPermissions"
import { useProductPositionActionHandlers } from "features/product-position-management/model/useProductPositionActionHandlers"

import { ProductPositionModel } from "../types/ProductPositionModel"

export function useProductPosition({
  productPosition,
  projectID
}: {
  productPosition: ProductPosition
  projectID: string
}): ProductPositionModel {
  const { permissions } = useProjectPermissions({ projectID })
  const handlers = useProductPositionActionHandlers({
    projectID,
    productPosition,
    permissions: permissions ?? readonlyProjectPermissions
  })
  const clarificationRequest = useClarificationRequestModel({
    resourceType: clarificationRequestResourceTypeMap.ProductPosition,
    id: productPosition.id,
    projectID,
    options: { skip: !productPosition.hasClarificationRequest }
  })

  return {
    core: {
      data: { productPosition: { data: productPosition } },
      handlers
    },
    clarificationRequest
  }
}
